module.exports = __webpack_public_path__ + "img/p2d_logo.d46db5fa.png";